import { spreadsheetPreviewCards } from '@/mocks/trending';

export default function SpreadsheetPreviewSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            Featured Spreadsheets
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
            Explore Our Curated Collections
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            Each pandabuyspreadsheet is carefully organized with verified links, QC photos, and community ratings
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {spreadsheetPreviewCards.map((card) => (
            <a
              key={card.title}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors duration-300"
            >
              <div className="relative overflow-hidden aspect-[4/3]">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  title={`PandaBuy Spreadsheet - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  View Spreadsheet
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}